import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ChevronDown, ShoppingBasket } from "lucide-react";

const Hero = () => {
  const navigate = useNavigate();
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-end">
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_bourgogne-escargots/artifacts/azgxztwr_WhatsApp%20Image%202026-07-02%20at%2010.19.14%20%289%29.jpeg"
          alt="Escargots en coquille, recette traditionnelle bourguignonne"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/35 to-black/20" />
        <div className="absolute inset-0 grain-overlay" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pb-20 lg:pb-28 w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl"
        >
          <span className="inline-block text-sm uppercase tracking-[0.3em] text-creme font-500">Escarg'Holala · Maison d'héliciculture depuis 2015</span>
          <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl text-white leading-[0.95] mt-4 tracking-tight">
            L'escargot gros gris,<br /> élevé et sublimé<br /> en Bourgogne.
          </h1>
          <p className="text-lg text-white/85 mt-6 leading-relaxed max-w-xl">
            Nichée à Savianges, notre maison cultive l'art de l'escargot, de l'élevage jusqu'à la table.
            Chaque pièce est travaillée à la main, avec exigence et générosité, pour révéler
            toute la finesse du terroir bourguignon.
          </p>
          <div className="flex flex-wrap gap-4 mt-9">
            <button
              data-testid="hero-order-btn"
              onClick={() => navigate("/commander")}
              className="rounded-full bg-bordeaux text-white font-600 px-8 py-4 hover:bg-bordeaux-dark transition-all hover:-translate-y-0.5 inline-flex items-center gap-2 shadow-lg shadow-black/20"
            >
              <ShoppingBasket size={19} /> Commander pour Noël 2026
            </button>
            <button
              data-testid="hero-products-btn"
              onClick={() => go("produits")}
              className="rounded-full border border-white/70 text-white font-600 px-7 py-3.5 hover:bg-white/10 transition-all backdrop-blur-sm"
            >
              Notre maison
            </button>
            <button
              data-testid="hero-visit-btn"
              onClick={() => go("visites")}
              className="rounded-full border border-white/70 text-white font-600 px-7 py-3.5 hover:bg-white/10 transition-all backdrop-blur-sm"
            >
              Réserver une visite
            </button>
          </div>
        </motion.div>
      </div>

      <button
        onClick={() => go("exploitation")}
        className="absolute bottom-7 left-1/2 -translate-x-1/2 z-10 text-white/70 hover:text-white transition-colors"
        aria-label="Défiler"
      >
        <ChevronDown size={30} className="animate-bounce" />
      </button>
    </section>
  );
};

export default Hero;
